<div class="container-fluid">

    <div class="row">
        <div class="row mb-15">
            <!-- Page Title Box -->
            <div class="col-lg-6">
                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                    <h4 class="mb-0 font-size-18"> Welcome To Ripple Dashboard!</h4>
                </div>
            </div>


            <div class="col-lg-6 d-flex justify-content-end align-items-end ">

                <ng-select [items]="residentialUnits" [clearable]="false" (change)="flatNoChange($event)" class="w-30"
                    style="margin-right: -239px;" placeholder="Select Flat No" bindLabel="flatNo"
                    [disabled]="residentialUnits.length==1? true:false" bindValue="residentialUnitId"
                    [(ngModel)]="selectedFlatno" [multiple]="false" [deselectOnClick]="false"></ng-select>

                <!-- Refresh Button -->
                <button class="btn btn-primary ml-237" kendoTooltip (click)="refreshBashboard()"
                    title="Clicking the 'Refresh' button will update the dashboard with the most recent information"
                    [position]="'left'">
                    <span><i class="fas fa-redo"></i> </span>&nbsp;&nbsp;Refresh
                </button>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-lg-6">
            <div class="card mini-stats-wid mini-stats-wid-border" *ngIf="isWalletEnabled">
                <div class="d-flex" [ngClass]="billingType === 'Postpaid'? 'h-105': ''">
                    <div class="d-flex px-3 py-2 col-lg-6 my-2"
                        [ngClass]="(isWalletEnabled && billingType === 'Postpaid') ? 'col-lg-6' : (isWalletEnabled ? 'col-lg-12' : 'col-lg-6')">
                        <div class="mr-3 cursor-pointer" (click)="onWalletClick()">
                            <p class="mb-0 mb-2 font-size-18">Wallet Balance</p>
                            <h4 class="font-weight-bold">
                                {{consumergraphdata?.currentWalletBalance!=null?(consumergraphdata.currentWalletBalance
                                |currency:'INR':true):'0'}}
                            </h4>
                        </div>
                        <div class=" ms-auto d-flex justify-content-center align-items-center">
                            <div class="">
                                <img src="../../../assets/images/brands/rupeemorenew.png" class="mt--2">
                            </div>
                        </div>
                    </div>
                    <ng-container *ngIf="billingType=='Postpaid'; else prepaid">
                        <div class="d-flex px-3 py-2 col-lg-6 rp-border-right my-2" *ngIf="billingType=='Postpaid'"
                            [ngClass]="(!isWalletEnabled && billingType === 'Postpaid') ? 'col-lg-12' : ''">
                            <div class="mr-3 cursor-pointer" (click)="onBillsClick('Unpaid Bill Amoun')">
                                <p class="mb-0 mb-2 font-size-18">Unpaid Bill Amount</p>
                                <h4 class="font-weight-bold">
                                    {{totalUnpaidBillsAmount!=null?(totalUnpaidBillsAmount
                                    |currency:'INR':true):'0'}}
                                </h4>
                                <span class="font-size-10 float-left" *ngIf="dueDate!=null">
                                    Due Date: {{dueDate!=null?
                                    (dueDate |
                                    date:'dd MMM yyyy'
                                    )
                                    :'-' }}</span>
                                <p>
                                </p>


                            </div>
                            <div class=" ms-auto d-flex justify-content-center align-items-center">
                                <img src="../../../assets/images/Bill UnPaid ICON 02.svg" class="w-76 h-50 mt--2">
                                <!--  <img src="../../../assets/images/brands/unpaid_stroke.svg" class="w-80"> -->

                            </div>
                        </div>
                    </ng-container>
                    <ng-template #prepaid>
                        <div class="d-flex px-3 py-2 col-lg-6 rp-border-right my-2">
                        </div>
                        <span>No status</span>
                    </ng-template>


                </div>
            </div>

            <div class="row">
                <div class="col-lg-6" *ngIf="isWalletEnabled ==true"
                    [ngClass]="(isWalletEnabled && billingType === 'Postpaid') ? 'col-lg-6' : (isWalletEnabled ? 'col-lg-6' : 'col-lg-6')">
                    <div class="card">
                        <div class="card-body p-3">
                            <h4 class="card-title mb-1">Last 5 recharges </h4>
                            <div *ngIf="last5Recharges &&  last5Recharges.length>0">
                                <kendo-chart (seriesClick)="onRechargesClick($event)"
                                    [ngClass]="(isWalletEnabled && billingType === 'Postpaid') ? 'h-275' : (isWalletEnabled ? 'h-275' : 'h-275')">
                                    <kendo-chart-category-axis>
                                        <kendo-chart-category-axis-item>
                                            <kendo-chart-category-axis-item-labels [rotation]="320">
                                            </kendo-chart-category-axis-item-labels>
                                        </kendo-chart-category-axis-item>
                                    </kendo-chart-category-axis>
                                    <kendo-chart-value-axis>
                                        <kendo-chart-value-axis-item [labels]="{ format: '₹ #.##' }">
                                            <!--  <kendo-chart-value-axis-item-labels [rotation]="45">
                                            </kendo-chart-value-axis-item-labels> -->
                                        </kendo-chart-value-axis-item>
                                    </kendo-chart-value-axis>
                                    <kendo-chart-series>
                                        <kendo-chart-series-item *ngFor="let series of last5Recharges"
                                            [data]="series.data" categoryField="category" field="value"
                                            [colorField]="'colorString'" [spacing]="0.25">
                                        </kendo-chart-series-item>
                                    </kendo-chart-series>

                                    <kendo-chart-tooltip format="₹{0}">
                                        <ng-template kendoChartTooltipTemplate let-tooltip="tooltip">
                                            <div>
                                                <strong>{{ tooltip.series.name }}</strong><br>
                                                Month: {{ tooltip.category }}<br>
                                                Value: {{ tooltip.value ? ('₹ ' + tooltip.value.toFixed(2)) : '' }}

                                            </div>
                                        </ng-template>
                                    </kendo-chart-tooltip>
                                </kendo-chart>
                            </div>
                            <div *ngIf="last5Recharges && last5Recharges.length==0"
                                class="recharges-no-data text-center d-flex justify-content-center align-items-center">
                                <p>No data available</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6" *ngIf="billingType=='Postpaid'">
                    <div class="card">
                        <div class="card-body p-3">
                            <h4 class="card-title mb-1">Last 5 Paid Bills</h4>
                            <div *ngIf="last5bills && last5bills.length>0">
                                <kendo-chart style="height: 275px;" (seriesClick)="onBillsClick($event)">
                                    <kendo-chart-category-axis>
                                        <kendo-chart-category-axis-item>
                                            <kendo-chart-category-axis-item-labels [rotation]="320">
                                            </kendo-chart-category-axis-item-labels>
                                        </kendo-chart-category-axis-item>
                                    </kendo-chart-category-axis>

                                    <kendo-chart-value-axis>
                                        <kendo-chart-value-axis-item [labels]="{ format: '₹ #.##' }">
                                            <!-- Rupee symbol for y-axis -->
                                        </kendo-chart-value-axis-item>
                                    </kendo-chart-value-axis>


                                    <kendo-chart-series>
                                        <kendo-chart-series-item *ngFor="let series of last5bills" [data]="series.data"
                                            categoryField="category" field="value" [colorField]="'colorString'"
                                            [spacing]="0.25">
                                        </kendo-chart-series-item>
                                    </kendo-chart-series>

                                    <kendo-chart-tooltip format="₹{0}">
                                        <ng-template kendoChartTooltipTemplate let-tooltip="tooltip">
                                            <div>
                                                <strong>{{ tooltip.series.name }}</strong>
                                                Month: {{ tooltip.category }}
                                                Value: {{ tooltip.value ? (tooltip.value |currency:'INR':true) : ''
                                                }}
                                            </div>
                                        </ng-template>
                                    </kendo-chart-tooltip>
                                </kendo-chart>
                            </div>
                            <div *ngIf="last5bills && last5bills.length==0"
                                class="bills-no-data text-center d-flex justify-content-center align-items-center superadminGraph">
                                <p>No data available</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6" *ngIf="billingType !=='Postpaid'">
                    <div class="card">
                        <div class="card-body p-3">
                            <h4 class="card-title mb-1">Last 5 Wallet deductions </h4>
                            <div *ngIf="last5deductionsPayments && last5deductionsPayments.length>0">
                                <kendo-chart (seriesClick)="onDeductionsClick($event)"
                                    [ngClass]="(isWalletEnabled && billingType === 'Prepaid') ? 'h-275' : (isWalletEnabled ? 'h-275' : 'h-275')">
                                    <kendo-chart-category-axis>
                                        <kendo-chart-category-axis-item>
                                            <kendo-chart-category-axis-item-labels [rotation]="320">
                                            </kendo-chart-category-axis-item-labels>
                                        </kendo-chart-category-axis-item>
                                    </kendo-chart-category-axis>

                                    <kendo-chart-value-axis>
                                        <kendo-chart-value-axis-item [labels]="{ format: '₹ #.##' }">
                                            <!-- Rupee symbol for y-axis -->
                                        </kendo-chart-value-axis-item>
                                    </kendo-chart-value-axis>

                                    <kendo-chart-series>
                                        <kendo-chart-series-item *ngFor="let series of last5deductionsPayments"
                                            [data]="series.data" categoryField="category" field="value"
                                            [colorField]="'colorString'" [spacing]="0.25">
                                        </kendo-chart-series-item>
                                    </kendo-chart-series>

                                    <kendo-chart-tooltip format=" ₹{0}">
                                        <ng-template kendoChartTooltipTemplate let-tooltip="tooltip">
                                            <div>
                                                <strong>{{ tooltip.series.name }}</strong>
                                                Month: {{ tooltip.category }}
                                                Value: {{ tooltip.value ? (tooltip.value |currency:'INR':true) : ''
                                                }}
                                            </div>
                                        </ng-template>
                                    </kendo-chart-tooltip>
                                </kendo-chart>
                            </div>
                            <div *ngIf="last5deductionsPayments &&  last5deductionsPayments.length==0"
                                class="bills-no-data text-center d-flex justify-content-center align-items-center mb-2 ">
                                <p>No data available</p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>


        </div>

        <div class="col-lg-6">
            <div class="card">
                <div class="card-body p-3">
                    <div class="d-flex justify-content-between align-items-center">
                        <div>
                            <h4 class="card-title">Meter Connections</h4>
                            <!--  <span class="text-muted font-size-12">No of connections</span> -->
                        </div>
                        <!-- <button class="btn btn-outline-secondary">More Details</button> -->
                    </div>

                    <!--  <div class="row mt-4">
                        <div class="col-xl-4" *ngFor="let item of consumerUtilityConnectionData">
                            <div class="card px-2 py-2 cursor-pointer" [ngClass]="{
                                'bg-electricity-subtle': item.utilityMasterName == 'Electricity', 
                                'bg-gas-subtle': item.utilityMasterName == 'Gas', 
                                'bg-water-subtle': item.utilityMasterName == 'Water',
                                'bg-ev-subtle': item.utilityMasterName == 'Ev',
                                'bg-triSource-subtle': item.utilityMasterName == 'TriSource'
                                
                                }" (click)="onUtilityClick(item.utilityMasterName) ">
                              
                                <div>
                                    <img [src]="'../../../assets/images/brands/admindashboardutilityimages/' + item.utilityMasterName + '.svg'"
                                        class="rp-icon">
                                </div>
                                <h4 class="mt-2">{{item.utilityMasterName}}</h4>
                                <p class="mb-1">
                                    {{ item.connectionsCount }} {{ item.connectionsCount > 1 ? 'Connections' :
                                    'Connection' }}
                                </p>


                                <p class="font-size-10 mb-0">
                                    <span *ngIf="item.consumptionPercentage !=0"
                                        [innerHTML]="getIcon(item.consumptionPercentage)"></span>
                                    <span class="text-primary" *ngIf="item.yesterdayConsumption == 'Consumption'">
                                        
                                        {{ item.consumptionPercentage != null && item.consumptionPercentage !==
                                        undefined
                                        ? (item.consumptionPercentage === 0
                                        ? 0
                                        : getAbsoluteConsumption(item.consumptionPercentage))
                                        : 'N/A' }}
                                        <span>%</span>
                                        {{ billingType == 'Postpaid' ? 'from last Month' : 'from yesterday' }}
                                    </span>
                                    <span class="text-primary" *ngIf="item.yesterdayConsumption === 'No Consumption'">
                                        <i class="fas fa-arrow-up text-danger"></i>
                                        <ng-container>
                                            0%&nbsp;
                                        </ng-container>
                                        {{ billingType === 'Postpaid' ? 'from yesterday' : 'from yesterday' }}
                                    </span>
                                    
                                </p>
                            </div>
                        </div>
                    </div> -->
                   
                    <div class="carousel-wrapper">

                        <!-- LEFT ARROW -->
                        <button class="arrow-btn left" (click)="slideLeft()" *ngIf="consumerUtilityConnectionData.length>3">
                            <i class="fa fa-chevron-left"></i>
                        </button>

                        <!-- SLIDER CONTAINER -->
                        <div class="carousel-container" #carousel>
                            <div class="meter-card" *ngFor="let item of consumerUtilityConnectionData"
                                [ngClass]="getCardClass(item)" (click)="onUtilityClick(item.utilityMasterName)">

                                <img [src]="'../../../assets/images/brands/admindashboardutilityimages/' + item.utilityMasterName + '.svg'"
                                    class="rp-icon">

                                <h4>{{ item.utilityMasterName }}</h4>

                               <!--  <p>{{ item.connectionsCount | number:'1.2-2'}} Connection</p> -->
                                <p>{{ item.connectionsCount }} Connection</p>

                                <p class="font-size-10 mb-0">
                                    <span *ngIf="item.consumptionPercentage !=0" [innerHTML]="getIcon(item.consumptionPercentage)"></span>
                                    <span class="text-primary" *ngIf="item.yesterdayConsumption == 'Consumption'">
                                
                                        {{ item.consumptionPercentage != null && item.consumptionPercentage !==
                                        undefined
                                        ? (item.consumptionPercentage === 0
                                        ? 0
                                        : getAbsoluteConsumption(item.consumptionPercentage))
                                        : 'N/A' }}
                                        <span>%</span>
                                        {{ billingType == 'Postpaid' ? 'from last Month' : 'from yesterday' }}
                                    </span>
                                    <span class="text-primary" *ngIf="item.yesterdayConsumption === 'No Consumption'">
                                        <i class="fas fa-arrow-up text-danger"></i>
                                        <ng-container>
                                            0%&nbsp;
                                        </ng-container>
                                        {{ billingType === 'Postpaid' ? 'from yesterday' : 'from yesterday' }}
                                    </span>
                                
                                </p>
                                <!-- <p class="font-size-10">
                                    <span [innerHTML]="getIcon(item.consumptionPercentage)"></span>
                                    {{ item.consumptionPercentage | number:'1.2-2'}}%
                                </p> -->
                            </div>
                        </div>

                        <!-- RIGHT ARROW -->
                        <button class="arrow-btn right" (click)="slideRight()" *ngIf="consumerUtilityConnectionData.length>3">
                            <i class="fa fa-chevron-right"></i>
                        </button>

                    </div>


                    <div class="row">
                        <!--  <h4 class="card-title mb-2"> Meter Connections</h4> -->
                        <div [ngClass]="billingType === 'Postpaid'? 'managCard': 'managCard225'"    
                            *ngIf="electricityConnections &&  electricityConnections.length>0">
                            <div class="col mx-3" *ngFor="let item of electricityConnections">
                                <div class="row">
                                    <div class="card bg-subtle px-2 py-2" [ngStyle]="{
                                        'background-color': utility === 'Gas' ? '#FFFBD4' : utility === 'Water' ? '#DFEDFF' :utility === 'Electricity'?  '#D7FFE3':'#ECFEFF'
                                      }">
                                        <div *ngIf="utility.toUpperCase() ==  'ELECTRICITY' || utility.toUpperCase() ==  'TRISOURCE'"
                                            class="d-flex justify-content-between align-items-center mt-2 font-size-12 text-muted">
                                            <label for="" class="text-muted font-size-12 mb-0">
                                                Current Power Source </label>

                                            <p class="mb-0 text-dark font-size-12">
                                                <b><b>{{ item.currentlyRunningOn !== undefined &&
                                                        item.currentlyRunningOn !== '' ? item.currentlyRunningOn : '--'
                                                        }}</b>

                                                </b>

                                            </p>
                                        </div>

                                        <div class="d-flex justify-content-between align-items-center">
                                            <label class="text-muted font-size-12" for="">Device Sr No:</label>
                                            <p class="mb-0 font-size-12"> <b>{{item.meterSerialNo}}</b></p>

                                        </div>

                                        <div class="d-flex justify-content-between align-items-center">
                                            <label class="text-muted font-size-12" for="">Installed Location:</label>
                                            <p class="font-weight-bolder mt-2 mb-2 font-size-12">
                                                <b> {{item.installedLocation}} </b>
                                            </p>

                                        </div>
                                        <hr class="hr">
                                        <div *ngIf="utility.toUpperCase() =='GAS' || utility.toUpperCase() =='WATER'"
                                            class="d-flex justify-content-between align-items-center ">
                                            <label for="" class="text-muted font-size-12 mb-0">Unbilled
                                                consumption:</label>
                                            <p class="font-weight-bolder mt-2 mb-2 font-size-12"><b> {{ utility ==
                                                    'Water'
                                                    ? (item.unbilledConsumption | number:'1.2-2') +
                                                    'L ' : utility == 'Gas' ?
                                                    (item.unbilledConsumption | number:'1.2-2') + '
                                                    m³': '-'}}</b> </p>
                                        </div>
                                        <div *ngIf="utility.toUpperCase() ==  'ELECTRICITY' || utility.toUpperCase() ==  'TRISOURCE'"
                                            class="d-flex justify-content-between align-items-center  ">
                                            <label for="" class="text-muted font-size-12 ">Unbilled
                                                consumption EB:</label>
                                            <p class="font-weight-bolder font-size-12">
                                                <b>{{ utility == 'Electricity' ? (item.unbilledConsumptionEB | number:'1.2-2')+ ' kWh'
                                                    :
                                                    '-'}}</b>

                                            </p>
                                        </div>
                                        <div *ngIf="utility.toUpperCase() ==  'ELECTRICITY' || utility.toUpperCase() ==  'TRISOURCE'"
                                            class="d-flex justify-content-between align-items-center ">
                                            <label for="" class="text-muted font-size-12 mb-0">Unbilled
                                                consumption DG:</label>
                                            <p class="font-weight-bolder font-size-12">
                                                <b> {{ utility == 'Electricity' ? (item.unbilledConsumptionDG | number:'1.2-2')+ ' kWh'
                                                    :
                                                    '-'}}</b>
                                            </p>
                                        </div>

                                        <div
                                            class="d-flex justify-content-between align-items-center mt-2 font-size-12 text-muted">
                                            <label for="" class="text-muted font-size-12 mb-0"> Unbillied
                                                Consumption
                                                from :
                                            </label>
                                            <p class="mb-0 text-dark font-size-12">
                                                <b> {{item?.startDateFormatted!=null?
                                                    (item?.startDateFormatted | date:'d MMM yyyy HH:mm a')
                                                    :'-' }} </b>

                                            </p>

                                        </div>
                                        <div
                                            class="d-flex justify-content-between align-items-center mt-2 font-size-12 text-muted">
                                            <label for="" class="text-muted font-size-12 mb-0"> Unbillied
                                                Consumption
                                                to:</label>
                                            <p class="mb-0 text-dark font-size-12">
                                                <b>Till Now </b>

                                            </p>
                                        </div>
                                        <div *ngIf="utility === 'Water' || utility == 'Gas'"
                                            class="d-flex justify-content-between align-items-center mt-2 font-size-12 text-muted">
                                            <label for="" class="text-muted font-size-12 mb-0">
                                                Last billed reading</label>

                                            <p class="mb-0 text-dark font-size-12">
                                                <b>
                                                    {{
                                                    utility === 'Water'
                                                    ? (item.lastBilledReading | number:'1.2-2')+ ' L'
                                                    : utility === 'Gas'
                                                    ? (item.lastBilledReading | number:'1.2-2') + ' m³'
                                                    : '-'
                                                    }}
                                                </b>
                                            </p>
                                        </div>
                                        <div *ngIf="utility === 'Electricity' || utility === 'TriSource'"
                                            class="d-flex justify-content-between align-items-center mt-2 font-size-12 text-muted">
                                            <label for="" class="text-muted font-size-12 mb-0">
                                                Last billed reading Eb</label>

                                            <p class="mb-0 text-dark font-size-12">
                                                <b>
                                                    {{
                                                    (utility === 'Electricity' || utility === 'TriSource')
                                                    ? (item.lastBilledReadingEB | number:'1.2-2') + ' kWh'
                                                    : '-'
                                                    }}
                                                </b>
                                        </div>
                                        <div *ngIf="utility === 'Electricity' || utility === 'TriSource'"
                                            class="d-flex justify-content-between align-items-center mt-2 font-size-12 text-muted">
                                            <label for="" class="text-muted font-size-12 mb-0">
                                                Last billed reading DG</label>

                                            <p class="mb-0 text-dark font-size-12">
                                                <b>
                                                    {{
                                                    (utility === 'Electricity' || utility === 'TriSource')
                                                    ? (item.lastBilledReadingDG | number:'1.2-2') + ' kWh'
                                                    : '-'
                                                    }}
                                                </b>
                                            </p>
                                        </div>
                                        <div
                                            class="d-flex justify-content-between align-items-center mt-2 font-size-12 text-muted">
                                            <label for="" class="text-muted font-size-12 mb-0">Bill Completed till
                                                :</label>
                                            <p class="mb-0 text-dark font-size-12">
                                                <b> {{item?.lastBiiledDate!=null?
                                                    (item?.lastBiiledDate | date:'d MMM yyyy HH:mm a')
                                                    :'-' }} </b>

                                            </p>
                                        </div>
                                        <div
                                            class="d-flex justify-content-between align-items-center mt-2 font-size-12 text-muted">
                                            <label for="" class="text-muted font-size-12 mb-0">
                                                Unbilled Days</label>

                                            <p class="mb-0 text-dark font-size-12">
                                                <b>{{item.noOfUnbilledDays}}</b>

                                            </p>
                                        </div>
                                        <!-- <div *ngIf="utility.toUpperCase() ==  'ELECTRICITY' || utility.toUpperCase() ==  'TRISOURCE'"
                                            class="d-flex justify-content-between align-items-center mt-2 font-size-12 text-muted">
                                            <label for="" class="text-muted font-size-12 mb-0">
                                                Current Power Source </label>

                                            <p class="mb-0 text-dark font-size-12">
                                                <b>{{item.currentlyRunningOn !== undefined
                                                    ? item.currentlyRunningOn:'--' }}</b>

                                            </p>
                                        </div> -->

                                    </div>

                                </div>
                            </div>
                        </div>
                        <div *ngIf="electricityConnections && electricityConnections?.length==0"
                            class="connection-no-data text-center d-flex justify-content-center align-items-center my-3">
                            <p>No data available</p>
                        </div>
                    </div>

                    <div *ngIf="meterConnectionLoding" class="chart-loader">
                        <div class="spinner"></div>
                    </div>
                </div>

            </div>

        </div>

        <div class="col-12">
            <div class="card">
                <div class="card-body p-3" style="width: 100%; overflow: hidden">
                    @if(ismonthlyConsumption){ <h4 class="card-title me-3">Consumption(Total units
                        consumed:{{consumptionData.length>0?sumOfTotalConsumption:0}}) </h4>}
                    @else{
                    <h4 class="card-title me-3">Consumption(Total units
                        consumed:{{monthlyConsumptionchartData.length>0?sumOfTotalConsumption:0}}) </h4>}

                    <div class="d-flex  justify-content-end">
                        <div class="d-flex justify-content-end">
                            <div class="position-relative flex-grow-1 me-2 " *ngIf="dateRange">
                                <input type="text" class="form-control date " style="width: 238px;"
                                    [value]="filterProjectBillDates ? (formatDateRange(filterProjectBillDates)) : ''"
                                    placeholder="Select Date" name="daterange" autocomplete="off" bsDaterangepicker
                                    [bsConfig]="datePickerConfig" [(bsValue)]="filterProjectBillDates"
                                    (bsValueChange)="onDateRangeSelected($event)" />
                                <span class="bx bx-calendar inputIcon" (click)="openCalendar()"></span>
                                <span class="bx bx-x inputIcon clear-icon" *ngIf="filterProjectBillDates"
                                    (click)="clearDate()"></span>
                            </div>

                            <div class=" flex-grow-1  me-2">
                                <ng-select [items]="months" [clearable]="false" (change)="selectionChange($event)"
                                    placeholder="Select Month" id="billingType" [(ngModel)]="selectedRange"
                                    [multiple]="false" [deselectOnClick]="false"></ng-select>
                            </div>
                            <div class=" flex-grow-1 ">
                                <ng-select [items]="projectUtlityList" [clearable]="false"
                                    [(ngModel)]="consuptionSelectedUtility"
                                    (change)="consuprtionUtilitiesChange($event)" bindValue="id" bindLabel="name"
                                    [multiple]=" false" [deselectOnClick]="false"></ng-select>
                            </div>

                        </div>
                    </div>

                    @if(ismonthlyConsumption){

                    <div *ngIf="consumptionData && consumptionData.length>0">
                        <apx-chart #chart class="cursor-pointer" [series]="chartOptions.series"
                            [colors]="chartOptions.colors" [chart]="chartOptions.chart" [xaxis]="chartOptions.xaxis"
                            [yaxis]="chartOptions.yaxis" [dataLabels]="chartOptions.dataLabels"
                            [stroke]="chartOptions.stroke" [markers]="chartOptions.markers"
                            [tooltip]="chartOptions.tooltip" [fill]="chartOptions.fill">
                        </apx-chart>

                        <div class="d-flex justify-content-end text-danger">
                            <span>*{{selectedUtilityName?.name =='Water'?
                                selectedUtilityName?.name +
                                ' in Liters':
                                (selectedUtilityName?.name =='EB' || selectedUtilityName?.name =='DG')?
                                selectedUtilityName?.name +
                                ' in kWh':

                                selectedUtilityName?.name +' in m³'}} </span>
                           
                        </div>

                    </div>
                    <div *ngIf="consumptionData &&consumptionData.length==0"
                        class="bills-no-data text-center d-flex justify-content-center align-items-center superadminGraph">
                        <p>No data available</p>
                    </div>
                    }@else{
                    <div *ngIf="monthlyConsumptionchartData && monthlyConsumptionchartData.length>0">

                        <kendo-chart style="height: 250px;">
                            <kendo-chart-series>
                                <kendo-chart-series-item [data]="monthlyConsumptionchartData" field="value"
                                    categoryField="category" [colorField]="'colorString'"
                                    [labels]="{ visible: true, content: labelContent }" [visible]="seriesVisible"
                                    [tooltip]="{ visible: true }" [spacing]="1">
                                </kendo-chart-series-item>
                            </kendo-chart-series>
                            <kendo-chart-legend position="bottom"></kendo-chart-legend>
                            
                        </kendo-chart>
                        <div class="d-flex justify-content-end text-danger">
                            <span>*{{selectedUtilityName?.name =='Water'?
                                selectedUtilityName?.name +
                                ' in Liters':
                                (selectedUtilityName?.name =='DG' || selectedUtilityName?.name =='EB')?
                                selectedUtilityName?.name +
                                ' in kWh':
                                selectedUtilityName?.name +' in m³'}} </span>
                          
                        </div>
                    </div>
                    <div *ngIf="monthlyConsumptionchartData && monthlyConsumptionchartData.length==0"
                        class="bills-no-data text-center d-flex justify-content-center align-items-center superadminGraph">
                        <p>No data available</p>
                    </div>

                    }
                </div>
            </div>
        </div>

    </div>
</div>